import { apiService } from './api.service';

export type RecommendationPayload = {
  id: string;
  triggerStepKey: string;
  mode: 'NOT_AT_FAULT' | 'AT_FAULT';
  confidence: 'LOW' | 'MEDIUM' | 'HIGH';
  fit?: 'STRONG_FIT' | 'WEAK_FIT' | 'MISMATCH';
  advisoryText?: string;
  bullets?: string[];
  action: 'PROCEED' | 'ASK_DETAILS' | 'OFFER_REDIRECT';
  offerRedirectToAtFault?: boolean;
  summary?: string;
  suggestedReasons?: string[];
  rollback_to_stepKey?: string | null;
  addDetailsUsed?: boolean;
  skipped?: boolean;
};

export type RecommendationResponse = {
  recommendation: RecommendationPayload | null;
};

export const recommendationService = {
  async refresh(
    sessionId: string,
    payload: { stepKey: string; stepType?: string; inputType?: string }
  ): Promise<RecommendationResponse> {
    const response = await apiService.refreshRecommendation(sessionId, payload);
    return (response.data || response) as RecommendationResponse;
  },

  async submitFeedback(
    sessionId: string,
    recId: string,
    payload: {
      userDecision: 'CONTINUE' | 'ADD_DETAILS' | 'KEEP_ANYWAY' | 'GO_BACK';
      decisionPayload?: Record<string, any>;
      stepKey?: string;
    }
  ): Promise<void> {
    await apiService.submitRecommendationFeedback(sessionId, recId, payload);
  },

  async submitDecision(
    sessionId: string,
    payload: { stepKey: string; decision: 'CONTINUE' | 'DISMISSED' | 'ADD_DETAILS_OPENED' }
  ): Promise<void> {
    await apiService.aiReviewDecision(sessionId, payload);
  },

  async submitAddDetails(
    sessionId: string,
    payload: { stepKey: string; text: string }
  ): Promise<void> {
    await apiService.aiReviewAddDetails(sessionId, payload);
  },
};

export default recommendationService;
